import React, { useRef, useState } from "react";
import {
  Container,
  Icon,
  TitleContainer,
  TextAfterIcon,
  IconsAndTextContainer,
} from "./eventView.styles";
import _ from "lodash";
import { connect } from "react-redux";
import EditEvent from "../EditEvent/EditEvent";
import ReactTooltip from "react-tooltip";
import { isMobile } from "react-device-detect";
import useTeacheres from "../../useComponents/useTeachers";
import { getUsers } from "../../../actions/userActions";
import moment from "moment";
import { getStudentIncomes } from "../../../actions/incomesAction";
import { getStudentDiscountsAndObligations } from "../../../actions/discountsAndObligationsActions";
import { getAgreementDetails } from "../../../actions/agreementsActions";
import {
  getStudentEvents,
  getStudentEventCount,
} from "../../../actions/schedulerActions";
import {
  getStudentTextBooks,
  fetchTextBook,
} from "../../../actions/textBooksActions";
import { useEffect } from "react";
import { EventType } from "../../../constants/events";
import { sendWhatsAppEventMessage } from "../../../utils/events";

const eventStatusIcons = {
  0: "icons8-question-mark",
  1: "icons8-checkmark",
  2: "icons8-shekel",
  3: "icons8-cancel",
  4: "icons8-cancel-with-usd",
};

const drivingPermitsOptions = [
  { value: 1, label: "הכשרה" },
  { value: 2, label: "רענון נהיגה" },
  { value: 3, label: "מטרונית" },
  { value: 4, label: "מפרקית" },
  { value: 5, label: "אוטובוס חשמלי" },
  { value: 6, label: "אוטובוס" },
  { value: 7, label: "אוטובוס בינערוני" },
  { value: 8, label: "מיניבוס" },
  { value: 9, label: "הסבה לקו" },
];
const formatPhoneForWhatsapp = (phoneNumber) => {
  phoneNumber = phoneNumber.trim();
  phoneNumber = phoneNumber.replaceAll('-', '');
  if (phoneNumber.includes('+972')) return phoneNumber;
  else if (phoneNumber.includes('972')) return '+' + phoneNumber;
  else {
    return '+972' + phoneNumber;
  }
}

const EventAgendaView = (event) => {
  const [balance, setBalance] = useState(0);
  const [displayBalance, setDisplayBalance] = useState(false);
  const [isEditLessonModalOpen, setIsEditLessonModalOpen] = useState(false);
  const [studentEventCount, setStudentEventCount] = useState(0);
  const [isShowCount, setIsShowCount] = useState(false);
  const [studentProfile, setStudentProfile] = useState(null);
  const teachersOptions = useTeacheres(
    event.isUsersLoaded,
    event.getUsers,
    event.users
  );
  const [colors, setColors] = useState({background: event.chosenStudentColor, color: event.fontChosenStudentColor});

  const getEventTypeIcon = (eventType) => {
    switch (eventType) {
      case 1:
        return <Icon className="icons8-steering-wheel" />;
      case 2:
        return <Icon className="icons8-graduation-cap" />;
      case 3:
        return <Icon className="icons8-road" />;
      case 4:
        return <Icon className="icons8-tie" />;
      default:
        return "";
    }
  };

  const loadStudentProfile = async () => {
    const profile = await event.loadStudentProfile(event.event);
    setStudentProfile(profile)
  }

  const getStudentEventCount = async () => {
    if (!isShowCount) {
      await loadStudentProfile()
      setIsShowCount(true);
    } else {
      setIsShowCount(false);
    }
  };

  const getNameStyle = (studentData) => {
    let styles = {};
    if (studentData.internalTestStatus) {
      styles.borderTop = "1px solid black";
    }
    if (
      studentData.conversion ||
      studentData.refresh ||
      studentData.renewal ||
      studentData.control
    ) {
      styles.borderLeft = "1px solid black";
      styles.borderRight = "1px solid black";
    }
    if (
      studentData.fundingBody !== 999 &&
      studentData.fundingBody !== null &&
      typeof studentData.fundingBody !== "undefined"
    ) {
      styles.borderBottom = "1px solid black";
    }

    return styles;
  };

  const setStudentBalance = async () => {
    if (displayBalance) {
      setDisplayBalance(false);
    } else {
      await loadStudentProfile()
      setDisplayBalance(true);
    }
  };
  const format = 'hh:mm';

  return !isMobile ? (
    <Container
      dir="auto"
      chosenStudentColor={colors.background}
      fontChosenStudentColor={colors.color}
      isStudentChosen={
        typeof event.chosenStudentId !== "undefined" &&
        event.chosenStudentId === event.event.studentId
      }
    >
      <ReactTooltip
        place="top"
        type="light"
        effect="float"
        html={true}
        id={event.event.id.toString()}
      />
      {isEditLessonModalOpen && (
        <EditEvent
          isNewAgreementModalOpen={isEditLessonModalOpen}
          setNewAgreementModalIsOpen={setIsEditLessonModalOpen}
          step={event.eventTime}
          selectedEvent={{
            ...event.event,
            name: event.event.name
              ? event.event.name
              : `${event.event.studentId} - ${event.event.firstName} ${event.event.lastName}`,
          }}
        />
      )}
      <TitleContainer dir="auto" className="eventView" isDay={event.isMargin}>
        {event.showEventStatus ? (
          <IconsAndTextContainer
            onClick={() => event.openEventStatusChangeModal(event.event)}
            style={{ margin: 0 }}
          >
            <Icon
              className={eventStatusIcons[event.event.eventStatus]}
              aria-hidden="true"
            />
          </IconsAndTextContainer>
        ) : null}
        {event.showTime ? (
          <IconsAndTextContainer onClick={() => setIsEditLessonModalOpen(true)}>
            <Icon className="icons8-clock" />
            <TextAfterIcon>
              {Math.round((event.event.end - event.event.start) / 1000 / 60)}
            </TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
        {event.showEventType ? (
          <IconsAndTextContainer onClick={() => getStudentEventCount()}>
            {getEventTypeIcon(event.event.eventType)}
            <TextAfterIcon>
              {isShowCount ? studentProfile.totalEventsForType : event.event.title}
            </TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
        {event.showVehicle && typeof event.event.description === "string" ? (
          <IconsAndTextContainer>
            <Icon
              className="icons8-car"
              data-tip={`<span dir="auto">${event.event.description}</span>`}
              data-for={event.event.id.toString()}
            />
            <TextAfterIcon>{event.event.description}</TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
        {/* <IconsAndTextContainer>
          <Icon className="fa fa-book" aria-hidden="true" />
          <TextAfterIcon>כרטסת</TextAfterIcon>
        </IconsAndTextContainer> */}
        {event.showPickUpLocation &&
        typeof event.event.pickupLocationName === "string" &&
        event.event.pickupLocationName !== "ללא" ? (
          <IconsAndTextContainer
            onClick={() => event.openPickupModal(event.event.id)}
          >
            <Icon
              className="icons8-location"
              data-tip={`<span dir="auto">${event.event.pickupLocationName}</span>`}
              data-for={event.event.id.toString()}
            />
            <TextAfterIcon>{event.event.pickupLocationName}</TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
        {event.showStudent && typeof event.event.firstName === "string" ? (
          <IconsAndTextContainer
            // onClick={() => event.openStudentMenuModal(event.event)}
            onClick={() => event.onStudentClick({
              event: event.event,
              value: event.event.studentId,
              label: `${event.event.firstName} ${event.event.lastName}`,
            })}
          >
            {/*<Icon
              className="icons8-user-group-man-man"
              data-tip={`<span dir="auto">${event.event.firstName} ${
                event.event.lastName
              }</span><br/><span dir="auto">${
                event.event.address ? event.event.address : ""
              }, ${
                event.event.city ? event.event.city : ""
              }</span><br/><span dir="auto">${event.event.phone}</span>`}
              data-for={event.event.id.toString()}
            />*/}
            <Icon
              className="icons8-whatsapp"
              onClick={() => sendWhatsAppEventMessage(event.event, event.event, event.user)}
              data-tip={`<span dir="auto">${event.event.firstName} ${
                event.event.lastName
              }</span><br/><span dir="auto">${
                event.event.address ? event.event.address : ""
              }, ${
                event.event.city ? event.event.city : ""
              }</span><br/><span dir="auto">${event.event.phone}</span>`}
              data-for={event.event.id.toString()}
            />
            <TextAfterIcon
              isDay={event.isDay}
              style={{
                ...getNameStyle(event.event),
              }}
            >
              {event.event.firstName}&nbsp;
              {typeof event.event.nickname === "string" &&
                `(${event.event.nickname}) `}
              {event.event.lastName}
            </TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
        {event.showDrivingPermit &&
        typeof event.event.drivingPermitId === "string" &&
        event.event.drivingPermitId !== "6" ? (
          <IconsAndTextContainer>
            <Icon className="fa fa-id-card" />
            <TextAfterIcon>
              {
                drivingPermitsOptions.find(
                  (x) => x.value.toString() === event.event.drivingPermitId
                )?.label
              }
            </TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
        {event.showBalance ? (
          <IconsAndTextContainer onClick={() => setStudentBalance()}>
            <Icon className="icons8-scales" />
            {displayBalance && <TextAfterIcon>{studentProfile.studentBalance}</TextAfterIcon>}
          </IconsAndTextContainer>
        ) : null}
        {event.showNotes && typeof event.event.notes === "string" ? (
          <IconsAndTextContainer
            data-tip={event.event.notes}
            onClick={() => event.openNotesChangeModal(event.event)}
            data-for={event.event.id.toString()}
          >
            <Icon className="icons8-comments" />
            {<TextAfterIcon>{event.event.notes}</TextAfterIcon>}
          </IconsAndTextContainer>
        ) : null}
        {event.showBranch && event.event.eventType !== 4 ? (
          <IconsAndTextContainer>
            <Icon className="fa fa-building" />
            <TextAfterIcon>{event.event.branchName}</TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
        {event.showTeacher &&
        teachersOptions.length !== 0 &&
        event.event.teacherId !== null ? (
          <IconsAndTextContainer>
            <Icon className="icons8-classroom" />
            <TextAfterIcon>
              {
                teachersOptions.find(
                  (x) => x.value.toString() === event.event.teacherId.toString()
                )?.label
              }
            </TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
        {event.showHealthDeclaration ? (
          <IconsAndTextContainer
            onClick={() => event.openSignatureModal(event.event)}
          >
            <Icon className="fa fa-ambulance" />
          </IconsAndTextContainer>
        ) : null}
      </TitleContainer>
    </Container>
  ) : (
    <Container
      dir="auto"
      chosenStudentColor={colors.background}
      fontChosenStudentColor={colors.color}
      isStudentChosen={
        typeof event.chosenStudentId !== "undefined" &&
        event.chosenStudentId === event.event.studentId
      }
    >
      {isEditLessonModalOpen && (
        <EditEvent
          isNewAgreementModalOpen={isEditLessonModalOpen}
          setNewAgreementModalIsOpen={setIsEditLessonModalOpen}
          step={event.eventTime}
          selectedEvent={{
            ...event.event,
            name: event.event.name
              ? event.event.name
              : `${event.event.studentId} - ${event.event.firstName} ${event.event.lastName}`,
          }}
        />
      )}
      <TitleContainer dir="auto" className="eventView" isDay={event.isMargin}>
        {event.showNotes ? (
          <IconsAndTextContainer
            data-tip={event.event.notes}
            onClick={() => event.openEventStatusChangeModal(event.event)}
            style={{ margin: 0 }}
            data-for={event.event.id.toString()}
          >
            <Icon
              className={eventStatusIcons[event.event.eventStatus]}
              aria-hidden="true"
            />
          </IconsAndTextContainer>
        ) : null}
        {event.showTime ? (
          <IconsAndTextContainer onClick={() => setIsEditLessonModalOpen(true)}>
            <Icon className="icons8-clock" />
            <TextAfterIcon>
              {Math.round((event.event.end - event.event.start) / 1000 / 60)}
            </TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
        {event.showEventType ? (
          <IconsAndTextContainer onClick={() => getStudentEventCount()}>
            {getEventTypeIcon(event.event.eventType)}
            <TextAfterIcon>
              {isShowCount ? studentProfile.totalEventsForType : event.event.title}
            </TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
        {event.showBalance ? (
          <IconsAndTextContainer onClick={() => setStudentBalance()}>
            <Icon className="icons8-scales" />
            {displayBalance && <TextAfterIcon>{studentProfile.studentBalanceWithFutureBalance}</TextAfterIcon>}
          </IconsAndTextContainer>
        ) : null}
        {event.showNotes && typeof event.event.notes === "string" ? (
          <IconsAndTextContainer
            data-tip={event.event.notes}
            onClick={() => event.openNotesChangeModal(event.event)}
            data-for={event.event.id.toString()}
          >
            <Icon className="icons8-comments" />
            <TextAfterIcon />
          </IconsAndTextContainer>
        ) : null}
      </TitleContainer>
      <div style={{display: 'flex', width: '280px', flexWrap: 'wrap'}}>
        {event.showStudent && typeof event.event.firstName === "string" ? (
          <IconsAndTextContainer
            // onClick={() => event.openStudentMenuModal(event.event)}
            onClick={() => event.onStudentClick({
              event: event.event,
              value: event.event.studentId,
              label: `${event.event.firstName} ${event.event.lastName}`,
            })}
          >
            {/*<Icon
              className="icons8-user-group-man-man"
              data-tip={`<span dir="auto">${event.event.firstName} ${event.event.lastName}</span><br/><span dir="auto">${event.event.address}, ${event.event.city}</span><br/><span dir="auto">${event.event.phone}</span>`}
              data-for={event.event.id.toString()}
            />*/}
            <Icon
              className="icons8-whatsapp"
              onClick={() => sendWhatsAppEventMessage(event.event, event.event, event.user)}
              data-tip={`<span dir="auto">${event.event.firstName} ${event.event.lastName}</span><br/><span dir="auto">${event.event.address}, ${event.event.city}</span><br/><span dir="auto">${event.event.phone}</span>`}
              data-for={event.event.id.toString()}
            />
            <TextAfterIcon
              isDay={event.isDay}
              style={{
                ...getNameStyle(event.event),
              }}
            >
              {event.event.firstName}&nbsp;
              {typeof event.event.nickname === "string" &&
                `(${event.event.nickname}) `}
              {event.event.lastName}
            </TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
        {event.showVehicle && typeof event.event.description === "string" ? (
          <IconsAndTextContainer>
            <Icon
              className="icons8-car"
              data-tip={`<span dir="auto">${event.event.description}</span>`}
              data-for={event.event.id.toString()}
            />
            <TextAfterIcon>{event.event.description}</TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
        {typeof event.event.pickupLocationName === "string" &&
        event.event.pickupLocationName !== "ללא" ? (
          <IconsAndTextContainer
            onClick={() => event.openPickupModal(event.event.id)}
          >
            <Icon
              className="icons8-location"
              data-tip={`<span dir="auto">${event.event.pickupLocationName}</span>`}
              data-for={event.event.id.toString()}
            />
            <TextAfterIcon>{event.event.pickupLocationName}</TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
        {event.showBranch && event.event.eventType !== 4 ? (
          <IconsAndTextContainer>
            <Icon className="fa fa-building" />
            <TextAfterIcon>{event.event.branchName}</TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
        {event.showTeacher &&
        teachersOptions.length !== 0 &&
        event.event.teacherId !== null ? (
          <IconsAndTextContainer>
            <Icon className="icons8-classroom" />
            <TextAfterIcon>
              {
                teachersOptions.find(
                  (x) => x.value.toString() === event.event.teacherId.toString()
                )?.label
              }
            </TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
        {event.showHealthDeclaration ? (
          <IconsAndTextContainer
            onClick={() => event.openSignatureModal(event.event)}
          >
            <Icon className="fa fa-ambulance" />
          </IconsAndTextContainer>
        ) : null}
      </div>
    </Container>
  );
};

function mapStateToProps(state, ownProps) {
  return {
    showEventType: state.session.user.showEventType,
    eventTime: state.session.user.eventTime,
    showEventStatus: state.session.user.showEventStatus,
    showStudent: state.session.user.showStudent,
    showVehicle: state.session.user.showVehicle,
    showHealthDeclaration: state.session.user.showHealthDeclaration,
    showTime: state.session.user.showTime,
    showBalance: state.session.user.showBalance,
    showBranch: state.session.user.showBranch,
    showNotes: state.session.user.showNotes,
    showTeacher: state.session.user.showTeacher,
    showPickUpLocation: state.session.user.showPickUpLocation,
    isUsersLoaded: state.UsersReducer.isLoaded,
    users: state.UsersReducer.users,
    chosenStudentColor: state.session.user.chosenStudentColor,
    fontChosenStudentColor: state.session.user.fontChosenStudentColor,
    user: state.session.user,
  };
}

export default connect(mapStateToProps, {
  getUsers,
  getAgreementDetails,
  getStudentEvents,
  getStudentEventCount,
  getStudentTextBooks,
  fetchTextBook,
  getStudentIncomes,
  getStudentDiscountsAndObligations,
})(EventAgendaView);
